export default {"src":"/_next/static/media/island.46b571be.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};